export const ERROR_TYPE_ACCESS_DENIED = 'access_denied';
export const ERROR_TYPE_TOO_MANY_REQUESTS = 'too_many_requests';
export const ERROR_TYPE_PASSWORD_EXPIRED = 'password_expired';
